import { render, staticRenderFns } from "./SalaryTemplateDelete.vue?vue&type=template&id=1381dfad"
import script from "./SalaryTemplateDelete.vue?vue&type=script&lang=js"
export * from "./SalaryTemplateDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports